import { Suspense } from "react";
import { Outlet, useLocation } from "react-router-dom";
import AiBanner from "@/components/AiBanner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageSkeleton from "@/components/PageSkeleton";
import { usePresenceTracker } from "@/hooks/usePresenceTracker";

const PAGE_TITLES: Record<string, string> = {
  "/": "Home",
  "/blog": "Blog",
  "/projects": "Projects",
  "/case-studies": "Case Studies",
  "/contact": "Contact",
  "/about": "About",
  "/ai": "AI",
  "/music": "Music",
  "/privacy": "Privacy",
};

export default function Layout() {
  const location = useLocation();
  const pagePath = location.pathname;
  const pageTitle = PAGE_TITLES[pagePath] || pagePath;

  usePresenceTracker(pagePath, pageTitle);

  return (
    <>
      <AiBanner />
      <Navbar />
      <Suspense fallback={<PageSkeleton />}>
        <Outlet />
      </Suspense>
      <Footer />
    </>
  );
}
